module.exports = __webpack_public_path__ + "img/IS491008-0160.c452b7c9.png";